import createModel, { arbitraryKeys } from "@/__main__/data-model.mjs";
import { model as Set } from "@/data-models/tft-set.mjs";

const Champion = {
  ...Set,
  apiKey: String,
};

const apiModelValidation = createModel({
  [arbitraryKeys]: Champion,
});

function transform(data) {
  return apiModelValidation(data);
}

export default transform;

export type TftChampionsV2 = ReturnType<typeof transform>;
